var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseReadmore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 5,
    viewBox: "0 0 14 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.859375 2.96875C0.708333 3.03125 0.585938 3.125 0.492188 3.25C0.398438 3.375 0.351562 3.51562 0.351562 3.67188C0.351562 3.91667 0.432292 4.11979 0.59375 4.28125C0.755208 4.44271 0.950521 4.52344 1.17969 4.52344C1.30469 4.52344 1.4401 4.4974 1.58594 4.44531C1.73177 4.38802 1.85938 4.33854 1.96875 4.29688L7.49219 2.09375H6.5L12.0156 4.29688C12.1302 4.33854 12.2604 4.38802 12.4062 4.44531C12.5521 4.4974 12.6849 4.52344 12.8047 4.52344C13.0391 4.52344 13.2344 4.44271 13.3906 4.28125C13.5521 4.11979 13.6328 3.91667 13.6328 3.67188C13.6328 3.51562 13.5859 3.375 13.4922 3.25C13.3984 3.125 13.276 3.03125 13.125 2.96875L8.11719 0.976562C7.92969 0.898438 7.73958 0.828125 7.54688 0.765625C7.35417 0.697917 7.17188 0.664062 7 0.664062C6.82292 0.664062 6.63802 0.697917 6.44531 0.765625C6.2526 0.828125 6.0651 0.898438 5.88281 0.976562L0.859375 2.96875Z",
    fill: "#5D2E7A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseReadmore);
export default __webpack_public_path__ + "static/media/close-readmore.f201580705592cab8f2e4b4e2b126dc1.svg";
export { ForwardRef as ReactComponent };